import { toast } from 'sonner';
import { useOutreachThreadActions } from '@discovr/features';
import type { OutreachRow } from '@discovr/types';
import { ActionConfirmDialog } from '../../../components/common/ActionConfirmDialog/ActionConfirmDialog';
import { stopDescription } from './ThreadMessageCard';

export interface RowStopTarget {
  row: OutreachRow;
  messageId: number;
}

interface RowStopDialogProps {
  campaignId: string;
  target: RowStopTarget | null;
  onClose: () => void;
}

/** E9-172: the row menu's Stop, same cancel and same words as the thread drawer's. */
export function RowStopDialog({ campaignId, target, onClose }: RowStopDialogProps) {
  const { cancel } = useOutreachThreadActions(campaignId, target?.row.entryId ?? '');
  const last = target?.row.lastMessage;
  const message = { kind: last?.kind ?? '', status: last?.status ?? 'queued' };
  return (
    <ActionConfirmDialog
      open={target !== null}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      variant="delete"
      title="Stop this send?"
      description={stopDescription(message, target?.row.outreachState !== 'sourced')}
      confirmLabel="Stop send"
      busy={cancel.isPending}
      onConfirm={() => {
        if (!target) return;
        cancel.mutate(target.messageId, {
          onError: () => toast.error('Could not stop the send. Try again.'),
          onSettled: onClose,
        });
      }}
    />
  );
}
